import { IVehicle } from "@/types/vehicle.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { getCompanyId } from "./company.api";



const API_URL = `${import.meta.env.VITE_API_URL}/precollection`;
const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function preUnlinkVehicleRenter(data) {
  const url = `${API_URL}/unlink-vehicle`;

  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...data, companyId: getCompanyId() }),
  };

  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<unknown>
  >;

  return result;
}


export async function getVehicleList() {
  const url = `${API_URL}/vehicles-list`;
  const result = (await makeRequest(url)) as ApiResponseType<IVehicle[]>;

  return { ok: result.ok, data: result.data };
}